module.exports = __webpack_public_path__ + "static/media/warranty3_top.77b926cc.png";